import i18n from 'i18next';

export default () => (
  [
    {
      key: 'home',
      text: i18n.t('home'),
      to: '/student/videos',
    },
    {
      key: 'my-videos',
      text: i18n.t('my-videos'),
      to: '/student/videos/my-videos',
    },
  ]
);
